<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header
            @back="goBack"
            :content="`${list.total_count ? list.total_count : 0} 项任务`"
          ></el-page-header>
        </div>
      </div>
      <div class="search" style="width:300px;">
        <el-input
          v-model="query.keyword"
          placeholder="请输入搜索关键字"
          style="width:180px;"
          suffix-icon="el-icon-search"
          @change="
            query.pageIndex = 1;
            initData();
          "
        >
        </el-input>
        <el-button
          icon="el-icon-plus"
          @click="
            dialogTaskVisible = true;
            initRelationData();
          "
          >发布任务</el-button
        >
      </div>
    </div>

    <section class="uc-examList">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <div class="title">
          <router-link
            :to="{ name: 'ShituMasterTaskDetails', params: { id: item.id } }"
          >
            <div class="c el-icon-s-operation">
              {{ item.title }}
            </div>
          </router-link>
          <router-link
            to=""
            @click.native="
              dialogTaskVisible = true;
              initRelationData();
              getTaskDetails(item.id);
            "
            v-if="item.is_self"
          >
            <i class="el-icon-edit"></i>
          </router-link>
        </div>
        <div class="con">
          <div class="sub-item w50">
            <i class="el-icon-s-custom"></i> 创建人：{{ item.create_user_name }}
          </div>
          <div class="sub-item w50">
            <i class="el-icon-time"></i> 任务期限：{{ item.start_time }} ~
            {{ item.finish_time }}
          </div>
          <div
            v-bind:class="{ expansion: item.is_long_content }"
            class="sub-item w100"
            v-html="`<i class=el-icon-document></i> 任务内容：${item.content}`"
          ></div>
          <el-button
            type="text"
            v-if="item.is_show_content"
            v-on:click="item.is_long_content = !item.is_long_content"
          >
            <span
              v-html="
                item.is_long_content
                  ? '展开内容<i class=el-icon-arrow-down></i>'
                  : '收起内容<i class=el-icon-arrow-up></i>'
              "
            >
            </span>
          </el-button>
          <div
            v-bind:class="{ expansion: item.is_long_objective }"
            class="sub-item w100"
            v-html="
              `<i class=el-icon-document></i> 达成目标：${item.objective}`
            "
          ></div>
          <div class="sub-item w100">
            <el-button
              type="text"
              v-if="item.is_show_objective"
              v-on:click="item.is_long_objective = !item.is_long_objective"
            >
              <span
                v-html="
                  item.is_long_objective
                    ? '展开目标<i class=el-icon-arrow-down></i>'
                    : '收起目标<i class=el-icon-arrow-up></i>'
                "
              >
              </span>
            </el-button>
          </div>
          <div class="sub-item w100">
            <i class="el-icon-user"></i> 任务对象：
            <span v-for="(item2, index2) in item.task_users" :key="index2"
              >{{
                (index2 == item.task_users.length - 1 &&
                  item2.apprentice_name) ||
                  item2.apprentice_name + '，'
              }}
            </span>
          </div>
          <div class="sub-item w100">
            <i class="el-icon-connection"></i> 任务状态：<span
              v-if="item.approval_status == 0"
            >
              <el-tag type="warning" size="small">
                {{ item.approval_status_text }}
              </el-tag>
              <i class="el-icon-arrow-right"></i>
              <el-button
                type="text"
                v-on:click="
                  dialogApprovalVisible = true;
                  approvalForm.id = item.id;
                "
                >去审核</el-button
              >
            </span>
            <span v-else-if="item.approval_status == 1">
              <el-tag type="success" size="small">
                {{ item.approval_status_text }}
              </el-tag>
            </span>
            <span v-else>
              <el-tag type="danger" size="small">
                {{ item.approval_status_text }}
              </el-tag>
              <i class="el-icon-arrow-right"></i>
              <el-button
                type="text"
                v-on:click="handleClickReason(`${item.approval_reason}`)"
                >驳回原因</el-button
              >
            </span>
          </div>
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="任务审核"
      :visible.sync="dialogApprovalVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseApprovalDialog"
    >
      <el-form :model="approvalForm" ref="approvalForm" :rules="approvalRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="approvalForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="审核状态"
          prop="approval_status"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="approvalForm.approval_status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="通过"
            inactive-text="驳回"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          label="驳回原因"
          prop="approval_reason"
          :label-width="formLabelWidth"
          v-if="!approvalForm.approval_status"
        >
          <el-input
            type="textarea"
            v-model.trim="approvalForm.approval_reason"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleApproval">取 消</el-button>
        <el-button type="primary" @click.native="handleApprovalSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="师徒任务"
      :visible.sync="dialogTaskVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseTaskDialog"
    >
      <el-form :model="taskForm" ref="taskForm" :rules="taskRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="taskForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="任务期限"
          prop="task_time"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="taskForm.task_time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="完成日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="任务对象"
          prop="apprentice"
          :label-width="formLabelWidth"
        >
          <el-select
            style="width:100%;"
            v-model="taskForm.apprentice"
            multiple
            placeholder="请选择徒弟，可多选"
          >
            <el-option
              v-for="(item, index) in relationList"
              :key="index"
              :label="item.apprentice_name"
              :value="item.apprentice_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="任务标题"
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-input v-model.trim="taskForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="任务内容"
          prop="content"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="taskForm.content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="达成目标"
          prop="objective"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="taskForm.objective"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleTask">取 消</el-button>
        <el-button type="primary" @click.native="handleTaskSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MasterApprenticeTask',
  data() {
    return {
      query: {
        type: 1,
        apprenticeId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      queryRelation: {
        type: 1,
        relationStatus: undefined,
      },
      list: [],
      relationList: [],
      dialogTaskVisible: false,
      pickerOptions: {
        disabledDate: (time) => {
          const one = 1 * 24 * 60 * 60 * 1000;
          const now = Date.now() - one;
          return time.getTime() < now;
        },
      },
      taskForm: {
        id: 0,
        apprentice: '',
        task_time: '',
        title: '',
        content: '',
        objective: '',
      },
      taskRules: {
        apprentice: [
          { required: true, message: '请选择徒弟', trigger: 'blur' },
        ],
        task_time: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入任务内容', trigger: 'blur' },
        ],
        objective: [
          { required: true, message: '请输入达成目标', trigger: 'blur' },
        ],
      },
      dialogApprovalVisible: false,
      approvalForm: {
        id: 0,
        approval_status: true,
        approval_reason: '',
      },
      approvalRules: {
        approval_reason: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituTasks();
    },
    async getShituTasks() {
      console.log(this.query);
      const response = await this.$api.shitu.getShituTasks(this.query);
      this.list = response.data.data;
    },
    initRelationData() {
      this.getShituRelations();
    },
    async getShituRelations() {
      const response = await this.$api.shitu.getShituRelations(
        this.queryRelation
      );
      this.relationList = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
    // ------------------任务审核-Begin------------------
    async editTaskApproval(task) {
      const response = await this.$api.shitu.editTaskApproval(task);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogApprovalVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.approvalForm.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleApprovalSubmitSure() {
      const submitData = {
        id: this.approvalForm.id,
        approval_status: this.approvalForm.approval_status ? 1 : 2,
        approval_reason: this.approvalForm.approval_reason,
      };
      this.$refs.approvalForm.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editTaskApproval(submitData);
        }
      });
    },
    handleCloseApprovalDialog() {
      this.$refs.approvalForm.resetFields();
    },
    handleCancleApproval() {
      this.dialogApprovalVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.approvalForm.resetFields();
      });
    },
    // 查看驳回原因
    handleClickReason(reason) {
      this.$alert(reason, '驳回原因', {
        dangerouslyUseHTMLString: true,
      });
    },
    // ------------------任务审核-End------------------

    // ------------------新增&编辑任务-Begin------------------
    async getTaskDetails(itemId) {
      const response = await this.$api.shitu.getTaskDetails({
        type: 1,
        id: itemId,
      });
      this.$nextTick(() => {
        this.taskForm = response.data.data;
      });
    },
    async editShituTask(task) {
      const response = await this.$api.shitu.masterEditShituTask(task);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogTaskVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.taskForm.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleTaskSubmitSure() {
      const submitData = {
        id: this.taskForm.id,
        apprentice: this.taskForm.apprentice,
        task_time: this.taskForm.task_time,
        title: this.taskForm.title,
        content: this.taskForm.content,
        objective: this.taskForm.objective,
      };
      this.$refs.taskForm.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editShituTask(submitData);
        }
      });
    },
    handleCloseTaskDialog() {
      this.$refs.taskForm.resetFields();
    },
    handleCancleTask() {
      this.dialogTaskVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.taskForm.resetFields();
      });
    },
    // ------------------新增&编辑任务-End------------------
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
